export default __webpack_public_path__ + "static/media/movieDesktop.9a806ad1.jpg";